<template>
  <v-dialog v-model="show" max-width="520px" persistent>
    <v-card class="collection-dialog-card">
      <div class="collection-dialog-header">
        <div>
          <div class="dialog-title">Select a Collection</div>
          <div class="dialog-subtitle">
            Choose which collection you want to order from.
          </div>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-4">
        <div v-if="collections.length === 0" class="empty-state">
          <v-icon size="46" color="orange lighten-1">
            mdi-alert-circle-outline
          </v-icon>

          <div class="empty-title">No collections found</div>

          <div class="empty-subtitle">
            Force Collection is enabled, but no collections are set up yet.
          </div>
        </div>

        <div v-else class="collection-list">
          <div
            v-for="collection in collections"
            :key="collection.id"
            class="collection-row"
            @click="selectCollection(collection)"
          >
            <div class="collection-icon">
              <v-icon small>mdi-shape-outline</v-icon>
            </div>

            <div class="collection-name">
              {{ collection.name }}
            </div>

            <v-spacer />

            <v-icon small color="grey">mdi-chevron-right</v-icon>
          </div>
        </div>
      </v-card-text>

      <v-divider v-if="collections.length === 0" />

      <v-card-actions v-if="collections.length === 0" class="pa-4">
        <v-spacer />
        <v-btn rounded outlined @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectCollectionDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    collections: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      show: this.value,
    };
  },

  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    },
  },

  methods: {
    selectCollection(collection) {
      this.$emit("select", collection);
      this.show = false;
    },

    close() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
.collection-dialog-card {
  border-radius: 20px;
  overflow: hidden;
}

.collection-dialog-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  background: #ffffff;
}

.dialog-title {
  font-size: 20px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.2;
}

.dialog-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.collection-list {
  display: grid;
  gap: 10px;
}

.collection-row {
  min-height: 58px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.18s ease;
}

.collection-row:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.collection-icon {
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 14px;
  background: #eef2ff;
  color: #4338ca;
  display: flex;
  align-items: center;
  justify-content: center;
}

.collection-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.empty-state {
  text-align: center;
  padding: 28px 12px;
}

.empty-title {
  font-size: 16px;
  font-weight: 900;
  color: #0f172a;
  margin-top: 10px;
}

.empty-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 4px auto 0;
  max-width: 320px;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .collection-dialog-header {
    padding: 16px;
  }

  .dialog-title {
    font-size: 18px;
  }

  .collection-row {
    border-radius: 14px;
  }
}
</style>